class DateRangeConfigFilter {
    multiplier: KnockoutObservable<number>;
    startDate: KnockoutObservable<string>;
    lastDateUsed: KnockoutObservable<number>;
    endDate: KnockoutObservable<string>;
    userDates: KnockoutObservable<boolean>;

    constructor(data) {
        this.multiplier = ko.observable(data?.multiplier || 0);
        this.startDate = ko.observable(data?.startDate);
        this.lastDateUsed = ko.observable(data?.lastDateUsed || 0);
        this.endDate = ko.observable(data?.endDate);
        this.userDates = ko.observable(data?.userDates || false);
    }
}